{
  "familyId": "REK-SCHATTEN",
  "questions": [
    {
      "id": "REK-SCHATTEN-001",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Je rekent 78 × 4. Welk antwoord kan NIET kloppen?",
      "options": ["3.120", "312", "292", "320"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 200,
            "end": 400,
            "step": 20,
            "highlight": [320],
            "marked": [292, 312, 320],
            "label": "Schatting: 80 × 4 = 320 — het antwoord ligt hier in de buurt"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schatten om te controleren",
            "content": "Schat eerst het antwoord vóór je rekent. 78 ≈ 80, dus 80 × 4 = 320. Het antwoord moet in de buurt van 320 liggen. 3.120 is bijna 10× te veel — dat kan niet kloppen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_controle",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Schat eerst het antwoord vóór je rekent. 78 ≈ 80, dus 80 × 4 = 320. Het antwoord moet in de buurt van 320 liggen. 3.120 is bijna 10× te veel — dat kan niet kloppen. Het echte antwoord is 312.",
        "solutionSteps": [
          "Rond af: 78 ≈ 80",
          "Reken: 80 × 4 = 320",
          "Het antwoord moet rond de 320 liggen",
          "3.120 is bijna 10× te groot — dat kan niet kloppen",
          "Check: het echte antwoord is 78 × 4 = 312 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 3.120 is veel te groot. De schatting 80 × 4 = 320, dus het antwoord moet rond de 300 liggen, niet rond de 3.000.",
          "1": "Je dacht waarschijnlijk dat 312 niet klopt. Maar 312 is precies het juiste antwoord van 78 × 4. Onthoud: schat eerst met een rond getal (80 × 4 = 320) en kijk welk antwoord ver weg ligt.",
          "2": "Je dacht waarschijnlijk dat 292 te ver weg ligt. Maar het verschil met het echte antwoord (312) is maar 20 — dat is dichtbij genoeg. Onthoud: bij schatten zoek je de uitbijter, niet een klein verschil.",
          "3": "Je dacht waarschijnlijk dat 320 niet klopt. Maar 320 is precies de schatting (80 × 4 = 320) en ligt heel dicht bij het echte antwoord (312). Onthoud: de schatting zelf kan ook een antwoord zijn."
        }
      }
    },
    {
      "id": "REK-SCHATTEN-002",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Een leraar geeft een rekentoets. Bij de som 49 + 52 schrijft een leerling als antwoord 91. De leraar zegt: \"Schat eerst om te controleren.\" Welke schatting laat zien dat 91 niet kan kloppen?",
      "options": [
        "40 + 50 = 90 — het antwoord moet rond de 90 liggen, dus 91 klopt wel",
        "49 + 50 = 99 — het antwoord is precies 99",
        "50 + 50 = 100 — het antwoord moet rond de 100 liggen, niet 91",
        "50 + 60 = 110 — het antwoord moet rond de 110 liggen"
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schatten om te controleren",
            "content": "Rond beide getallen af naar het dichtstbijzijnde tiental. 49 ≈ 50 en 52 ≈ 50. Dan reken je 50 + 50 = 100. Het echte antwoord moet rond de 100 liggen. 91 is te laag — de leerling heeft een fout gemaakt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_afronden_beide",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Rond beide getallen af: 49 ≈ 50 en 52 ≈ 50. Schatting: 50 + 50 = 100. Het echte antwoord is 101. De leerling schreef 91 — dat is bijna 10 te laag. De schatting laat zien dat er een fout zit in het antwoord van de leerling.",
        "solutionSteps": [
          "Rond af: 49 ≈ 50 en 52 ≈ 50",
          "Schatting: 50 + 50 = 100",
          "De leerling schreef 91 — dat is ~10 te laag",
          "Conclusie: 91 kan niet kloppen, het antwoord moet rond de 100 liggen"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 49 dichter bij 40 ligt. Maar 49 is slechts 1 verwijderd van 50 en 9 verwijderd van 40. De schatting 40 + 50 = 90 is onnauwkeurig en zou de fout (91) juist bevestigen. Onthoud: rond af naar het dichtstbijzijnde tiental voor de beste schatting.",
          "1": "Je dacht waarschijnlijk dat je maar één getal hoeft af te ronden. Maar 49 + 50 = 99 is geen schatting — je rekent dan bijna exact. Het doel van schatten is snel controleren met makkelijke getallen. Onthoud: rond beide getallen af.",
          "2": "Goed! 50 + 50 = 100 is de beste schatting. Het echte antwoord (101) ligt dicht bij 100, maar 91 is te ver weg — de leerling heeft een fout gemaakt.",
          "3": "Je dacht waarschijnlijk dat 52 dichter bij 60 ligt. Maar 52 is slechts 2 verwijderd van 50 en 8 verwijderd van 60. De schatting 50 + 60 = 110 is te hoog. Onthoud: rond af naar het dichtstbijzijnde tiental."
        }
      }
    },
    {
      "id": "REK-SCHATTEN-003",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Een boekhandelaar koopt 3 boeken van €8,95 in. Hoeveel betaalt hij ongeveer?",
      "options": ["ongeveer €24", "ongeveer €27", "ongeveer €30", "ongeveer €9"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden en dan rekenen",
            "content": "Rond het bedrag af naar een handig getal. €8,95 ≈ €9. Dan reken je: 3 × €9 = €27. Het echte antwoord is €26,85 — de schatting is heel goed!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_context_geld",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Rond het bedrag af naar een handig getal. €8,95 ≈ €9 (bijna 9 euro). Dan reken je: 3 × €9 = €27. Het echte antwoord is 3 × €8,95 = €26,85, dus de schatting van €27 is heel goed!",
        "solutionSteps": [
          "Rond af: €8,95 ≈ €9",
          "Reken: 3 × €9 = €27",
          "Check: het echte antwoord is 3 × €8,95 = €26,85 — dichtbij ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 × €9 = €27. Door €8,95 af te ronden naar €9 krijg je een snelle en nauwkeurige schatting.",
          "1": "Je dacht waarschijnlijk dat €8,95 dichter bij €8 ligt. Maar €8,95 is slechts 5 cent verwijderd van €9 en 95 cent verwijderd van €8. Onthoud: rond af naar het dichtstbijzijnde hele getal.",
          "2": "Je dacht waarschijnlijk dat €8,95 dichter bij €10 ligt. Maar €8,95 is slechts 5 cent verwijderd van €9 en €1,05 verwijderd van €10. Onthoud: rond af naar het dichtstbijzijnde hele getal, niet naar het volgende tiental.",
          "3": "Je dacht waarschijnlijk dat je maar 1 boek hoeft te berekenen. Maar de boekhandelaar koopt 3 boeken, dus je moet vermenigvuldigen: 3 × €9 = €27. Onthoud: lees goed hoeveel stuks er gevraagd worden."
        }
      }
    },
    {
      "id": "REK-SCHATTEN-004",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Een magazijnmedewerker moet 198 dozen verdelen over 4 stellingen. Welk antwoord past het best?",
      "options": ["ongeveer 40", "ongeveer 200", "ongeveer 500", "ongeveer 50"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden naar een deelbaar getal",
            "content": "Rond af naar een getal dat makkelijk deelbaar is. 198 ≈ 200, en 200 is makkelijk deelbaar door 4. 200 ÷ 4 = 50. Het echte antwoord is 49,5 — de schatting klopt!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_deling",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Rond af naar een getal dat makkelijk deelbaar is. 198 ≈ 200, en 200 is makkelijk deelbaar door 4. 200 ÷ 4 = 50. Het echte antwoord is 49,5, dus de schatting van 50 is uitstekend!",
        "solutionSteps": [
          "Rond af: 198 ≈ 200 (dichtbij en deelbaar door 4)",
          "Reken: 200 ÷ 4 = 50",
          "Check: het echte antwoord is 198 ÷ 4 = 49,5 — heel dichtbij ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 198 dichter bij 160 ligt (want 4 × 40 = 160). Maar 198 is veel groter dan 160. Onthoud: rond af naar het dichtstbijzijnde getal dat makkelijk deelbaar is — hier is dat 200.",
          "1": "Je dacht waarschijnlijk dat 200 het antwoord is. Maar 200 is het getal dat je deelt, niet het resultaat. 198 ÷ 4 ≈ 200 ÷ 4 = 50. Onthoud: het antwoord van een deling is altijd kleiner dan het oorspronkelijke getal.",
          "2": "Je dacht waarschijnlijk dat je moet vermenigvuldigen in plaats van delen. Maar 4 × 500 = 2.000 — dat is veel te groot. De magazijnmedewerker verdeelt 198 dozen, dus je deelt: 198 ÷ 4 ≈ 50. Onthoud: verdelen = delen.",
          "3": "Goed! 200 ÷ 4 = 50. Door 198 af te ronden naar 200 wordt de deling makkelijk."
        }
      }
    },
    {
      "id": "REK-SCHATTEN-005",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Een kassamedewerker controleert: 623 − 187. Welke schatting helpt haar het antwoord te controleren?",
      "options": [
        "600 − 200 = 400",
        "600 − 100 = 500",
        "700 − 200 = 500",
        "620 − 190 = 430"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op honderdtallen",
            "content": "Rond beide getallen af op honderdtallen voor een snelle controle. 623 ≈ 600 en 187 ≈ 200. Dan reken je: 600 − 200 = 400. Het echte antwoord is 436 — dichtbij!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_controle_aftrekking",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Rond beide getallen af op honderdtallen voor een snelle controle. 623 ≈ 600 en 187 ≈ 200. Dan reken je: 600 − 200 = 400. Het echte antwoord is 436, dus als de kassamedewerker iets rond de 400 krijgt, klopt het waarschijnlijk.",
        "solutionSteps": [
          "Rond af: 623 ≈ 600",
          "Rond af: 187 ≈ 200",
          "Reken: 600 − 200 = 400",
          "Check: het echte antwoord is 623 − 187 = 436 — dichtbij ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 600 − 200 = 400 is de handigste schatting. Beide getallen zijn afgerond op honderdtallen.",
          "1": "Je dacht waarschijnlijk dat 187 dichter bij 100 ligt. Maar 187 is slechts 13 verwijderd van 200 en 87 verwijderd van 100. Onthoud: rond af naar het dichtstbijzijnde honderdtal — het tientallencijfer 8 ≥ 5, dus omhoog naar 200.",
          "2": "Je dacht waarschijnlijk dat 623 dichter bij 700 ligt. Maar 623 is slechts 23 verwijderd van 600 en 77 verwijderd van 700. Onthoud: rond af naar het dichtstbijzijnde honderdtal.",
          "3": "Je dacht waarschijnlijk dat je zo nauwkeurig mogelijk moet afronden. Maar 620 − 190 = 430 is moeilijker uit het hoofd te rekenen dan 600 − 200 = 400. Onthoud: bij schatten kies je de makkelijkste getallen, niet de nauwkeurigste."
        }
      }
    },
    {
      "id": "REK-SCHATTEN-009",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "estimation_slider",
      "question": "Schat de uitkomst van 48 × 7. Waar hoort het antwoord op de getallenlijn?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 500,
        "correctValue": 336,
        "tolerancePercent": 15,
        "showNumberLine": true,
        "showValue": false
      },
      "conceptId": "schatten_slider_keer",
      "variantIndex": 9,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Rond 48 af naar 50. Reken 50 × 7 = 350. Het antwoord ligt in de buurt van 350. Het exacte antwoord is 336.",
        "solutionSteps": [
          "Rond af: 48 ≈ 50",
          "Reken: 50 × 7 = 350",
          "Plaats de schuif in de buurt van 350"
        ]
      }
    },
    {
      "id": "REK-SCHATTEN-010",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "estimation_slider",
      "question": "Schat de uitkomst van 812 ÷ 4. Waar hoort het antwoord op de getallenlijn?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 300,
        "correctValue": 203,
        "tolerancePercent": 15,
        "showNumberLine": true,
        "showValue": false
      },
      "conceptId": "schatten_slider_deel",
      "variantIndex": 10,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Rond 812 af naar 800. Reken 800 ÷ 4 = 200. Het antwoord ligt in de buurt van 200. Het exacte antwoord is 203.",
        "solutionSteps": [
          "Rond af: 812 ≈ 800",
          "Reken: 800 ÷ 4 = 200",
          "Plaats de schuif in de buurt van 200"
        ]
      }
    }
  ]
}